import { DatePipe } from '@angular/common';
import { Component, Inject, Input, OnInit, Optional } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { DashboardService } from 'app/dashboard/dashboard.service';
import { DiagnosisComponent } from 'app/EMR/Diagnosis/Diagnosis.component';
import { DiagnosisModel } from 'app/EMR/DoctorModels/diagnosis.model';
import { EMRService } from 'app/EMR/EMR.service';
import { OpdVisitService } from 'app/opdvisits/Services/OpdVisit.service';
import { DynamicHelpListComponent } from '../doctor-other-info/dynamic-help-list/dynamic-help-list.component';
import { HelpListPopupComponent } from '../doctor-other-info/help-list-popup/help-list-popup.component';
import { VoiceRecognitionService } from 'app/masters/service/voice-recognition.service';
import { Subject, interval } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import * as moment from 'moment';
import { AuthService } from 'app/auth/auth.service';
// import { Observable } from 'rxjs';
// import { map, startWith } from 'rxjs/operators';

@Component({
  selector: 'app-doctor-diagnosis',
  templateUrl: './doctor-diagnosis.component.html',
  styleUrls: ['./doctor-diagnosis.component.scss']
})
export class DoctorDiagnosisComponent implements OnInit {
  destroydia$: Subject<boolean> = new Subject<boolean>();
  private diagnosis_ds: MatTableDataSource<DiagnosisModel>
  private diagnosisMainArray: any = [];
  private examid: any;
  private showspinner: boolean = false;
  private examdetailArray: any = [];
  private diagnosisComments: string = '';
  // emrservice.enabledisablebtnDia:boolean =false;
  private displayedColumns_diagnosis: string[] = ['icd', 'diagnosis', 'type', 'site', 'Action'];
  // DiagnosisTypeCtrl: FormControl;
  //filtereddaignoTypeArray: Observable<any[]>;
  isheader: boolean = false;
  @Input() drDiagnosismodule: any;

  constructor(private service: VoiceRecognitionService,
    @Optional() @Inject(MAT_DIALOG_DATA) private data: any,
    private dialogRef: MatDialogRef<DoctorDiagnosisComponent>,
    private emrservice: EMRService, private dialog: MatDialog, private datePipe: DatePipe,
    private opdvisitService: OpdVisitService, private dashboardService: DashboardService, private authservice: AuthService) {
    this.service.init();
  }

  ngOnInit(): void {

    this.diagnosisMainArray = [];
    if (this.data) {
      this.isheader = this.data.isheader;
    } else {
      this.isheader = false;
    }
    this.emrservice.enabledisablebtnDia = true;
    this.examdetailArray = this.emrservice.patientEMRdetail;

    this.emrservice.share.pipe(takeUntil(this.destroydia$)).subscribe((x: any) => {
      if (x == 2) {
        this.examid = this.emrservice.examid;
        // this.GetFindingGResultByregid(this.opdvisitService.patientdetails.pkRegId);
        this.getDaigonisdataByRegid(this.opdvisitService.patientdetails.pkRegId);
      }
      if (x == 3) {
        this.examid = this.emrservice.examid;
        this.getDaigonisdataByRegid(this.opdvisitService.patientdetails.pkRegId);
        //  this.diagnosis_ds.data = this.diagnosisMainArray.filter(item => item.fK_ExamId == this.emrservice.examid);
        // this.opdvisitService.patientDrdetaill =this.opdvisitService.patientDrdetaill.filter(item=>item.pK_ExamId ==this.emrservice.examid);
      }
      if (x == 22) {
        this.examid = this.emrservice.examid;
      }
    });
     this.diagnosis_ds = new MatTableDataSource(this.emrservice.diagnosis.slice());

    // AI Scribe — pre-fill diagnoses from a voice consultation
    this.emrservice.aiWorkup$.pipe(takeUntil(this.destroydia$)).subscribe(() => this.consumeAiDiagnosis());
    interval(1500).pipe(takeUntil(this.destroydia$)).subscribe(() => this.consumeAiDiagnosis());

    // this.DaignosisTypeControll();
    //this.getSite();
    this.emrservice.transferArraydiagonsis.pipe(takeUntil(this.destroydia$)).subscribe((itemarray: any) => {
      debugger
      this.diagnosisMainArray = [];
      if (itemarray.length > 0) {
        this.emrservice.enabledisablebtnDia = false;
        itemarray?.forEach(item => {
          this.diagnosisMainArray.push({
            "pK_TranId": 0,
            "fK_ExamId": this.examid,
            "pk_DiagnosisId": item.fK_DiagnosisId,
            "fK_DgCategoryId": 0,
            "icdcode": item.icdCode,
            "diagnosisName": item.diagnosisName,
            "isHeading": null,
            "isActive": true,
            "pk_SynchId": item.pk_SynchId,
            "isSelect": true,
            "site": item.remarks,
            "diagnosisType": item.diagnosisType,
            "remarks": '',
            "isEdit": false,
            "date": this.datePipe.transform(new Date(), "yyyy-MM-dd"),
            "isDeleted": 0,
            "oldExamId": null,
            "isHidden": null
          });
        });
        this.diagnosis_ds = new MatTableDataSource(this.diagnosisMainArray.slice());


      }
    }, err => {
      if (err.status == 403) {
        this.dashboardService.openSnackBar("You Don't have Permission", "OK");
      }
      else if (err.error.statusCode == 422) {
        this.dashboardService.openSnackBar(err.error.message, "OK");
      }
      else {
        this.dashboardService.openSnackBar("API Failed", "OK");
      }
    });
    this.emrservice.componentClicked$.subscribe(() => {
      if (!this.emrservice.enabledisablebtnDia) {
        setTimeout(() => {
          if (this.emrservice.examid > 0) {
            this.examid = this.emrservice.examid;
            this.SavedaignosisAll(true, 1);
          }
        }, 600);

      }
    });
  }
  ngOnDestroy() {
    this.destroydia$.next(true);
    this.destroydia$.unsubscribe();
    this.examdetailArray = null;
    this.diagnosisMainArray = null;
    this.diagnosis_ds.data = null;
    this.displayedColumns_diagnosis = null;
    this.emrservice.transferArraydiagonsis = null;
  }

  /** AI Scribe: pull diagnoses in, then resolve each name to the ICD master id. */
  consumeAiDiagnosis(): void {
    const p = this.emrservice.aiWorkupPending;
    if (!p || !p.diagnoses || !p.diagnoses.length) { return; }
    // idempotent: skip if these AI rows are already on screen (survives retries)
    const shown = (this.diagnosis_ds && this.diagnosis_ds.data) || [];
    if (shown.some((r: any) => r && r.aiSuggested)) { return; }
    const aiList = p.diagnoses.slice();   // do NOT clear — allow re-apply after API reloads
    this.diagnosisMainArray = shown.slice();
    const startIdx = this.diagnosisMainArray.length;
    aiList.forEach((r: any) => {
      this.diagnosisMainArray.push({
        pK_TranId: 0, fK_ExamId: this.examid, pk_DiagnosisId: 0, fK_DgCategoryId: 0,
        icdcode: r.icdcode || '', diagnosisName: r.diagnosisName || '', isHeading: null,
        isActive: true, pk_SynchId: 0, isSelect: true, site: r.site || '',
        diagnosisType: r.diagnosisType || '', remarks: r.remarks || '', isEdit: false,
        date: this.datePipe.transform(new Date(), 'yyyy-MM-dd'), isDeleted: 0,
        oldExamId: null, isHidden: null, aiSuggested: true, aiUnmatched: true,
      });
    });
    this.diagnosis_ds = new MatTableDataSource(this.diagnosisMainArray.slice());
    this.emrservice.enabledisablebtnDia = false;

    // resolve names -> ICD master (one call) and patch ids/codes
    this.emrservice.GetGetDiagnosis(0, 0, 0).pipe(takeUntil(this.destroydia$)).subscribe((master: any) => {
      const list = Array.isArray(master) ? master : [];
      aiList.forEach((r: any, k: number) => {
        const hit = this.matchByName(list, r.diagnosisName, 'diagnosisName');
        const row = this.diagnosisMainArray[startIdx + k];
        if (hit && row) {
          row.pk_DiagnosisId = hit.pk_DiagnosisId;
          row.icdcode = hit.icdCode || row.icdcode;
          row.diagnosisName = hit.diagnosisName;
          if (hit.fK_DgCategoryId) { row.fK_DgCategoryId = hit.fK_DgCategoryId; }
          if (hit.site && !row.site) { row.site = hit.site; }
          row.aiUnmatched = false;
        }
      });
      this.diagnosis_ds = new MatTableDataSource(this.diagnosisMainArray.slice());
    }, () => { /* keep name-only on error */ });
  }

  /** Per-tab AI fill — applies only this section's slice. */
  aiFillDiagnosis(s: any): void { this.emrservice.applyAiWorkup({ diagnoses: (s && s.diagnoses) || [] }); }

  /** Best-effort name match against a master list (exact, then contains). */
  private matchByName(list: any[], name: string, field: string): any | null {
    if (!name || !list || !list.length) { return null; }
    const n = ('' + name).toLowerCase().trim();
    let m = list.find((x) => ('' + (x[field] || '')).toLowerCase().trim() === n);
    if (!m) { m = list.find((x) => ('' + (x[field] || '')).toLowerCase().includes(n) || n.includes(('' + (x[field] || '')).toLowerCase())); }
    return m || null;
  }
  // getSite() {
  //   this.emrservice.getMasterSite().subscribe(data => {
  //     this.sitelist =[];
  //     this.sitelist = data;

  //   });
  // }
  GetFindingGResultByregid(regid) {

    this.emrservice.GetFindingGResultByregid(regid, this.opdvisitService.visitid, this.opdvisitService.DoctorIdEmr).pipe(takeUntil(this.destroydia$)).subscribe((x: any) => {
      this.examdetailArray = [];
      this.emrservice.patientEMRdetail = [];
      this.emrservice.patientEMRdetail = x;
      this.examdetailArray = this.emrservice.patientEMRdetail.filter(item => item.pK_ExamId == this.emrservice.examid);
      this.opdvisitService.patientDrdetaill[0].diagnosisComments = this.examdetailArray[0]?.diagnosisComments ? this.examdetailArray[0]?.diagnosisComments : null;
      this.getDaigonisdataByRegid(this.opdvisitService.patientdetails.pkRegId);
    }, err => {
      if (err.status == 403) {
        this.dashboardService.openSnackBar("You Don't have Permission", "OK");
      }
      else if (err.error.statusCode == 422) {
        this.dashboardService.openSnackBar(err.error.message, "OK");
      }
      else {
        this.dashboardService.openSnackBar("API Failed", "OK");
      }
    })
  }

  getDaigonisdataByRegid(regid) {
    this.emrservice.getDaigonosisbyRegid(regid, this.opdvisitService.visitid, this.opdvisitService.DoctorIdEmr).pipe(takeUntil(this.destroydia$)).subscribe(item => this.successDiagnosis(item), err => this.error_daigonosis(err));
  }
  successDiagnosis(item) { 
    if (item.length > 0) {
      this.diagnosisMainArray=[];
      item.forEach(data => {
        if (data.fK_ExamId == this.examid) {
          this.diagnosisMainArray.push({
            "pK_TranId": data.pK_TranId,
            "fK_ExamId": data.fK_ExamId,
            "pk_DiagnosisId": data.fK_DiagnosisId,
            "fK_DgCategoryId": null,
            "icdcode": data.icdCode,
            "diagnosisName": data.diagnosisName,
            "isHidden": data.isHidden,
            "pk_SynchId": 0,
            "isSelect": true,
            "site": data.remarks,
            "diagnosisType": data.diagnosisType,
            "remarks": data.remarks,
            "isEdit": data.pK_TranId > 0 ? true : false,
            "date": this.datePipe.transform(new Date(), "yyyy-MM-dd"),
            "isDeleted": 0,
            "oldExamId": data.oldExamId,
          });
        }

      });
      this.diagnosis_ds = new MatTableDataSource(this.diagnosisMainArray.slice());
    }

  }
  error_daigonosis(err) {
    if (err.status == 403) {
      this.dashboardService.openSnackBar("You Don't have Permission", "OK");
    }
    else if (err.error.statusCode == 422) {
      this.dashboardService.openSnackBar(err.error.message, "OK");
    }
    else {
      this.dashboardService.openSnackBar("API Failed", "OK");
    }
  }
  opendiagnosis(): void {
    if (this.emrservice.diagnosisPermission.isAddPermission == true) {

      const dialogRef = this.dialog.open(DiagnosisComponent, {
        panelClass: 'full-width-dialog',
        maxWidth: '90vw',
        width: '90%',
        disableClose: true
      });
      dialogRef.afterClosed().pipe(takeUntil(this.destroydia$)).subscribe(result => {

        if (result.length > 0) {
          const rdmedicine = result.filter(item2 => !this.diagnosisMainArray.some(item1 => item1.pk_DiagnosisId === item2.pk_DiagnosisId));
          this.emrservice.enabledisablebtnDia = false;
          rdmedicine?.forEach(item => {
            this.diagnosisMainArray.push({
              "pK_TranId": 0,
              "fK_ExamId": this.examid,
              "pk_DiagnosisId": item.pk_DiagnosisId,
              "fK_DgCategoryId": item.fK_DgCategoryId,
              "icdcode": item.icdCode,
              "diagnosisName": item.diagnosisName,
              "isHeading": item.isHeading,
              "isActive": item.isActive,
              "pk_SynchId": item.pk_SynchId,
              "isSelect": true,
              "site": item.site,
              "diagnosisType": '',
              "remarks": '',
              "isEdit": false,
              "date": this.datePipe.transform(new Date(), "yyyy-MM-dd"),
              "isDeleted": 0,
              "oldExamId": null,
              "isHidden": null
            });
          });
          this.diagnosis_ds = new MatTableDataSource(this.diagnosisMainArray.slice());
        }
      });

    } else {
      this.dashboardService.openSnackBar("Add permission denied", "ok");
    }
  }

  onSitechange(e: any, index: number) {
    if (e != null) {
      this.emrservice.enabledisablebtnDia = false;
      this.diagnosisMainArray[index].site = e;
      this.diagnosis_ds = new MatTableDataSource(this.diagnosisMainArray.slice());
    }

  }
  enableEditmode(e: any, index: number) {
    this.emrservice.enabledisablebtnDia = false;
    this.diagnosisMainArray[index].isEdit = true;
    this.diagnosis_ds = new MatTableDataSource(this.diagnosisMainArray.slice());
  }
  onDiagnosisChange(e: any, index: number) {
    if (e != null) {
      this.emrservice.enabledisablebtnDia = false;
      this.diagnosisMainArray[index].diagnosisName = e;
      this.diagnosis_ds = new MatTableDataSource(this.diagnosisMainArray.slice());
    }
  }
  onicdcodeChange(e: any, index: number) {
    if (e != null) {
      this.emrservice.enabledisablebtnDia = false;
      this.diagnosisMainArray[index].icdcode = e;
      this.diagnosis_ds = new MatTableDataSource(this.diagnosisMainArray.slice());
    }
  }
  // onDatechange(e: any, index: number) {
  //   if (e != null) {
  //     this.diagnosisMainArray[index].date = this.datePipe.transform(e, "yyyy-MM-dd");
  //     this.diagnosis_ds = new MatTableDataSource(this.diagnosisMainArray.slice());
  //   }
  // }
  onicdTypeChange(e: any, index: number) {

    if (e != null) {
      this.emrservice.enabledisablebtnDia = false;
      this.diagnosisMainArray[index].diagnosisType = e;
      this.diagnosis_ds = new MatTableDataSource(this.diagnosisMainArray.slice());
    }
  }
  // getDiagnosisTypeobj(e: any ,i) {
  //   debugger
  //   var val = e.option.value;
  //   if(val != null){
  //     this.onicdTypeChange(val.popupDescription ,i);
  //   }
  // }
  // CheckinputdaignosisType(event: any) {

  //   var checkdata = event.target.value;
  //   if (checkdata == "") {
  //     this.DaignosisTypeControll(); 
  //   }
  // }
  Cancelpopup(type) {
    if (type == 1) {
      if (this.emrservice.diagnosisPermission.isDeletePermission == true) {

        document.getElementById("daignosisModal").style.display = "Block";
      } else {
        this.dashboardService.openSnackBar("Delete permission denied", "ok");
      }
    } else {
      document.getElementById("daignosisModal").style.display = "None";
    }

  }
  // DaignosisTypeControll() {

  //   this.DiagnosisTypeCtrl = new FormControl();
  //   this.filtereddaignoTypeArray = this.DiagnosisTypeCtrl.valueChanges
  //     .pipe(
  //       startWith(''),
  //       map(cat => cat ? this.filterOpfunction(cat) : this.helpservice.eyeDiagnosistypes.slice())
  //     );

  // }

  // filterOpfunction(name: string) {
  //   const filterValue = name.toString().toLowerCase();
  //   return this.helpservice.eyeDiagnosistypes.filter(country =>
  //     country.popupDescription?.toLowerCase().indexOf(filterValue) === 0);

  // }
  reftypeReasonPOpup(type, index) {
    if (this.diagnosisMainArray.length > 0) {
      const dialogRef = this.dialog.open(HelpListPopupComponent, {
        panelClass: 'full-width-dialog',
        maxWidth: '33vw',
        disableClose: true,
        width: '33%',

        data: {
          typeid: type
        }

      });

      dialogRef.afterClosed().pipe(takeUntil(this.destroydia$)).subscribe(result => {
        if (result != 0) {
          if (type == 33) {
            this.emrservice.enabledisablebtnDia = false;
            this.diagnosisMainArray[index].diagnosisType = result;
            this.diagnosis_ds = new MatTableDataSource(this.diagnosisMainArray.slice());
          }

        }
      });
    }

  }

  Changediatype($event, index) {
    this.emrservice.enabledisablebtnDia = false;
    this.diagnosisMainArray[index].diagnosisType = $event.target.value;
    this.diagnosis_ds = new MatTableDataSource(this.diagnosisMainArray.slice());
  }
  drDiagnosisdata: any = [];
  SavedaignosisAll(event, type: any) {
    if (Date.parse(this.datePipe.transform(new Date(this.authservice.localDate), "yyyy-MM-dd").toString()) == Date.parse(this.datePipe.transform(this.emrservice.visitDate, "yyyy-MM-dd").toString()) || this.authservice.Loggeduser.usertypeid == 9) {
      if (this.authservice.Loggeduser.usertypeid == 6) {
        if (this.authservice.Loggeduser.userid != this.opdvisitService.DoctorIdEmr) {
           this.showspinner = false;
          return this.dashboardService.openSnackBar("⁠You can not modify another's Dr workup.", "OK");
        }
      }
      if (this.emrservice.diagnosisPermission.isAddPermission == true) {
       
        this.drDiagnosisdata = [];
        if (this.emrservice.visitid != null && this.emrservice.visitid != undefined) {
          if (this.examid == null || this.examid == undefined) {
            this.examid = 0;
          }
          if (this.opdvisitService.patientdetails.pkRegId) {

            if (this.diagnosisMainArray.length > 0) {
              if (type == 0) {
                const button = (event.srcElement.disabled === undefined) ? event.srcElement.parentElement : event.srcElement;
                button.setAttribute('disabled', true);
                this.showspinner = true;
              }
              const getDuplicateIdCounts = this.emrservice.hasDuplicateIds(this.diagnosisMainArray, 'pk_DiagnosisId');
              if (getDuplicateIdCounts) {
                this.emrservice.enabledisablebtnDia = true;
                this.showspinner = false;
                return this.dashboardService.openSnackBar("Duplicate record not allowed", "OK");
              }
              this.diagnosisMainArray.forEach(item => {
                this.drDiagnosisdata.push({
                  "PK_TranId": item.pK_TranId ? item.pK_TranId : 0,
                  "FK_ExamId": this.examid,
                  "fK_DiagnosisId": item.pk_DiagnosisId,
                  "DiagnosisDate": item.date,
                  "diagnosisType": item.diagnosisType,
                  "remarks": item.site,
                  "OLDExamId": item.oldExamId,
                  "IsEdit": item.isEdit,
                  "IsHidden": item.isHidden,
                  "IsDeleted": item.isDeleted ? item.isDeleted : 0
                });
              });


              this.opdvisitService.patientDrdetaill[0].pK_ExamId = this.examid;
              this.opdvisitService.patientDrdetaill[0].fK_VisitId = this.emrservice.visitid;
              this.opdvisitService.patientDrdetaill[0].fK_DoctorId = this.opdvisitService.DoctorIdEmr;
              this.opdvisitService.patientDrdetaill[0].drFristDateTimeWorkupFinish = moment(JSON.parse(sessionStorage.getItem('SessiondateTime'))).format("HH:mm:ss");
              this.opdvisitService.patientDrdetaill[0].isEdit = this.examid > 0 ? true : false;
              let payload = {

                DrExam: {
                  ...this.opdvisitService.patientDrdetaill[0]

                },

                DrFinding: []
                ,
                DrDiag: this.drDiagnosisdata,
                DrPrescrip: [
                ],
                DrInvest: []
                , DrSurgery: []
              }
              try {
                this.emrservice.SaveDrwrokupData(payload).pipe(takeUntil(this.destroydia$)).subscribe(data => {
                  this.emrservice.enabledisablebtnDia = true;
                  this.showspinner = false;
                  if (data['statusCode'] == 1) {
                    if (this.examid > 0) {
                      this.emrservice.savedrWorkupTrackingSatus('Modify Doctor Workup', 'true', 'DR');
                    } else {
                      this.emrservice.savedrWorkupTrackingSatus('Doctor Workup', 'false', 'DR');
                    }
                    this.examid = data['id'];
                    this.emrservice.examid = data['id'];
                    this.emrservice.GetFindingGResultByregidd(this.opdvisitService.patientdetails.pkRegId, this.opdvisitService.visitid, this.opdvisitService.DoctorIdEmr, 1);
                    // this.emrservice.content.next('2');
                    this.getDaigonisdataByRegid(this.opdvisitService.patientdetails.pkRegId);

                    this.dashboardService.openSnackBar("Record Saved Successfully", "OK");
                    this.emrservice.drWorkupExamStatus(this.emrservice.visitid, this.emrservice.examid != null ? this.emrservice.examid : 0)
                  } else if (data['statusCode'] == 10) {
                    this.dashboardService.openSnackBar("Already exists in the list", "OK");
                  } else {
                    this.dashboardService.openSnackBar("API Failed", "OK");
                  }
                },
                  err => {
                    this.showspinner = false;
                    if (err.status == 403) {
                      this.dashboardService.openSnackBar("You Don't have Permission", "OK");
                    }
                    else if (err.error.statusCode == 422) {
                      this.dashboardService.openSnackBar(err.error.message, "OK");
                    }
                    else {
                      this.dashboardService.openSnackBar("API Failed", "OK");
                    }

                  });
              }
              catch (error) {
                this.showspinner = false;
              }
            }
            else {
              this.showspinner = false;
              this.dashboardService.openSnackBar("Please Select Diagnosis", "OK");
            }
          } else {
            this.dashboardService.openSnackBar("Please Select Patient", "OK");
          }

        } else {
          this.dashboardService.openSnackBar("Please Select Visit List", "OK");
        }
      } else {
        this.dashboardService.openSnackBar("Add permission denied", "OK");
      }
    } else {
      this.dashboardService.openSnackBar("You don't have permission to modify back date visit", "OK");
    }
  }
  // delete functionality 
  deleterarray: any = [];
  deleteDiagnosis(row: any) {
    if (Date.parse(this.datePipe.transform(new Date(this.authservice.localDate), "yyyy-MM-dd").toString()) == Date.parse(this.datePipe.transform(this.emrservice.visitDate, "yyyy-MM-dd").toString()) || this.authservice.Loggeduser.usertypeid == 9) {
      if (this.authservice.Loggeduser.usertypeid == 6) {
        if (this.authservice.Loggeduser.userid != this.opdvisitService.DoctorIdEmr) {
          return this.dashboardService.openSnackBar("⁠You can not modify another's Dr workup.", "OK");
        }
      }
      const index: number = this.diagnosisMainArray.indexOf(row);
      if (index !== -1) {
        if (row.pK_TranId == 0) {
          this.diagnosisMainArray.splice(index, 1);
          this.diagnosis_ds = new MatTableDataSource(this.diagnosisMainArray.slice());
          if(this.diagnosis_ds.data.length ==0){
               this.emrservice.enabledisablebtnDia = true;
          }   
          // this.deleteDiagnosisdata(row, 1);
        } else {
          if (this.emrservice.diagnosisPermission.isDeletePermission == true) {
            this.emrservice.enabledisablebtnDia = false;
            this.diagnosisMainArray.splice(index, 1);
            this.diagnosis_ds = new MatTableDataSource(this.diagnosisMainArray.slice());
            this.diagnosisMainArray.push({
              "pK_TranId": row.pK_TranId,
              "fK_ExamId": row.fK_ExamId,
              "pk_DiagnosisId": row.pk_DiagnosisId,
              "date": this.datePipe.transform(new Date(), "yyyy-MM-dd"),
              "icdcode": row.icdcode,
              "diagnosisType": row.diagnosisType,
              "remarks": row.remarks,
              "site": row.remarks,
              "oldExamId": row.oldExamId,
              "isEdit": 1,
              "isHidden": row.isHidden,
              "isDeleted": 1
            });

            this.deleteDiagnosisdata(row, 1);

          } else {
            this.dashboardService.openSnackBar("Delete permission denied", "ok");
          }
        }

      }
    } else {
      this.dashboardService.openSnackBar("You don't have permission to modify back date visit", "OK");
    }
  }
  enableButton($event) {
    this.emrservice.enabledisablebtnDia = false;
  }
  deleteDiagnosisdata(rowdata, type) {
    if (Date.parse(this.datePipe.transform(new Date(this.authservice.localDate), "yyyy-MM-dd").toString()) == Date.parse(this.datePipe.transform(this.emrservice.visitDate, "yyyy-MM-dd").toString()) || this.authservice.Loggeduser.usertypeid == 9) {
      if (this.authservice.Loggeduser.usertypeid == 6) {
        if (this.authservice.Loggeduser.userid != this.opdvisitService.DoctorIdEmr) {
          return this.dashboardService.openSnackBar("⁠You can not modify another's Dr workup.", "OK");
        }
      }
      if (type == 1) {
        if (rowdata.pK_TranId > 0) {
          this.deleterarray.push({
            "PK_TranId": rowdata.pK_TranId,
            "FK_ExamId": rowdata.fK_ExamId,
            "fK_DiagnosisId": rowdata.pk_DiagnosisId,
            "DiagnosisDate": rowdata.date,
            "diagnosisType": rowdata.diagnosisType,
            "remarks": rowdata.remarks,
            "OLDExamId": rowdata.oldExamId,
            "IsEdit": 1,
            "IsHidden": rowdata.isHidden,
            "IsDeleted": 1
          });
        }

      } else {
        rowdata?.forEach(item => {
          if (item.pK_TranId > 0) {
            this.deleterarray.push({
              "PK_TranId": item.pK_TranId,
              "FK_ExamId": item.fK_ExamId,
              "fK_DiagnosisId": item.pk_DiagnosisId,
              "DiagnosisDate": item.date,
              "diagnosisType": item.diagnosisType,
              "remarks": item.remarks,
              "OLDExamId": item.oldExamId,
              "IsEdit": 1,
              "IsHidden": item.isHidden,
              "IsDeleted": 1
            });
          }
        })
      }
      if (this.deleterarray.length > 0) {
        this.opdvisitService.patientDrdetaill[0].pK_ExamId = this.examid;
        this.opdvisitService.patientDrdetaill[0].fK_VisitId = this.emrservice.visitid;
        this.opdvisitService.patientDrdetaill[0].fK_DoctorId = this.opdvisitService.DoctorIdEmr;
        this.opdvisitService.patientDrdetaill[0].isEdit = this.examid > 0 ? true : false;
        let payload = {

          DrExam: {
            ...this.opdvisitService.patientDrdetaill[0]

          },

          DrFinding: []
          ,
          DrDiag: this.deleterarray,
          DrPrescrip: [
          ],
          DrInvest: []
          , DrSurgery: []
        }
        this.emrservice.SaveDrwrokupData(payload).pipe(takeUntil(this.destroydia$)).subscribe(data => {
          this.emrservice.enabledisablebtnDia = true;
          this.showspinner = false;
          if (data['statusCode'] == 1) {
            this.deleterarray = [];
            this.emrservice.GetFindingGResultByregidd(this.opdvisitService.patientdetails.pkRegId, this.opdvisitService.visitid, this.opdvisitService.DoctorIdEmr, 1);
            this.getDaigonisdataByRegid(this.opdvisitService.patientdetails.pkRegId);
            this.dashboardService.openSnackBar("Record Deleted Successfully", "OK");
            this.emrservice.drWorkupExamStatus(this.emrservice.visitid, this.emrservice.examid != null ? this.emrservice.examid : 0)
            document.getElementById("daignosisModal").style.display = "None";
            if (type == 2) {
              this.diagnosisMainArray = [];
            }
            if (this.diagnosisMainArray.length == 0) {
              this.diagnosis_ds = new MatTableDataSource(this.diagnosisMainArray.slice());
            }
          } else if (data['statusCode'] == 10) {
            this.dashboardService.openSnackBar("Already exists in the list", "OK");
          } else {
            this.dashboardService.openSnackBar("API Failed", "OK");
          }
        },
          err => {
            this.showspinner = false;
            if (err.status == 403) {
              this.dashboardService.openSnackBar("You Don't have Permission", "OK");
            }
            else if (err.error.statusCode == 422) {
              this.dashboardService.openSnackBar(err.error.message, "OK");
            }
            else {
              this.dashboardService.openSnackBar("API Failed", "OK");
            }

          });
      } else {
        if (type == 2) {
          this.diagnosisMainArray = [];
        }
        if (this.diagnosisMainArray.length == 0) {
          this.diagnosis_ds = new MatTableDataSource(this.diagnosisMainArray.slice());
        }
        this.showspinner = false;
        this.dashboardService.openSnackBar("Record Deleted Successfully", "OK");
        document.getElementById("daignosisModal").style.display = "None";
      }
    } else {
      this.dashboardService.openSnackBar("You don't have permission to modify back date visit", "OK");
    }
  }

  refReasonPOpup(type) {
    const dialogRef = this.dialog.open(DynamicHelpListComponent, {
      panelClass: 'full-width-dialog',
      maxWidth: '33vw',
      disableClose: true,
      width: '33%',

      data: {
        parametertype: type
      }

    });

    dialogRef.afterClosed().pipe(takeUntil(this.destroydia$)).subscribe(result => {
      if (result != 0) {
        this.emrservice.enabledisablebtnDia = false;
        this.opdvisitService.patientDrdetaill[0].diagnosisComments = result;

      }
    });
  }
  startService() {
    this.service.DCtext = '';
    this.service.start('Diagnosis Comments');
  }

  stopService() {
    this.emrservice.enabledisablebtnDia = false;
    this.opdvisitService.patientDrdetaill[0].diagnosisComments = this.service.DCtext;
    this.service.stop('Diagnosis Comments');
  }
  closedialog() {
    this.dialogRef.close();
  }

}
